import pizzaBuilderLogo from './pizza_builder_logo.webp';
import pizzaBuilderLogoSmall from './pizza_builder_logo_small.webp';
import pizzaBuilderMobileImage1 from './pizza_builder_mobile_1.webp';
import pizzaBuilderMobileImage2 from './pizza_builder_mobile_2.webp';
import pizzaBuilderMobileImage3 from './pizza_builder_mobile_3.webp';
import pizzaBuilderDesktopImage1Small from './pizza_builder_desktop_1_small.webp';
import pizzaBuilderDesktopImage1Medium from './pizza_builder_desktop_1_medium.webp';
import pizzaBuilderDesktopImage1Big from './pizza_builder_desktop_1_big.webp';
import pizzaBuilderDesktopImage1 from './pizza_builder_desktop_1.webp';
import pizzaBuilderDesktopImage2Small from './pizza_builder_desktop_2_small.webp';
import pizzaBuilderDesktopImage2Medium from './pizza_builder_desktop_2_medium.webp';
import pizzaBuilderDesktopImage2Big from './pizza_builder_desktop_2_big.webp';
import pizzaBuilderDesktopImage2 from './pizza_builder_desktop_2.webp';
import pizzaBuilderDesktopImage3Small from './pizza_builder_desktop_3_small.webp';
import pizzaBuilderDesktopImage3Medium from './pizza_builder_desktop_3_medium.webp';
import pizzaBuilderDesktopImage3Big from './pizza_builder_desktop_3_big.webp';
import pizzaBuilderDesktopImage3 from './pizza_builder_desktop_3.webp';

import pizzaVSLogo from './pizza_vs_logo.webp';
import pizzaVSLogoSmall from './pizza_vs_logo_small.webp';
import pizzaVSMobileImage1 from './pizza_vs_mobile_1.webp';
import pizzaVSMobileImage2 from './pizza_vs_mobile_2.webp';
import pizzaVSMobileImage3 from './pizza_vs_mobile_3.webp';
import pizzaVSDesktopImage1Small from './pizza_vs_desktop_1_small.webp';
import pizzaVSDesktopImage1Medium from './pizza_vs_desktop_1_medium.webp';
import pizzaVSDesktopImage1Big from './pizza_vs_desktop_1_big.webp';
import pizzaVSDesktopImage1 from './pizza_vs_desktop_1.webp';
import pizzaVSDesktopImage2Small from './pizza_vs_desktop_2_small.webp';
import pizzaVSDesktopImage2Medium from './pizza_vs_desktop_2_medium.webp';
import pizzaVSDesktopImage2Big from './pizza_vs_desktop_2_big.webp';
import pizzaVSDesktopImage2 from './pizza_vs_desktop_2.webp';
import pizzaVSDesktopImage3Small from './pizza_vs_desktop_3_small.webp';
import pizzaVSDesktopImage3Medium from './pizza_vs_desktop_3_medium.webp';
import pizzaVSDesktopImage3Big from './pizza_vs_desktop_3_big.webp';
import pizzaVSDesktopImage3 from './pizza_vs_desktop_3.webp';

import dnailsLogo from './dnails_logo.webp';
import dnailsLogoSmall from './dnails_logo_small.webp';
import dnailsMobileImage1 from './dnails_mobile_1.webp';
import dnailsMobileImage2 from './dnails_mobile_2.webp';
import dnailsMobileImage3 from './dnails_mobile_3.webp';
import dnailsMobileImage4 from './dnails_mobile_4.webp';
import dnailsDesktopImage1Small from './dnails_desktop_1_small.webp';
import dnailsDesktopImage1Medium from './dnails_desktop_1_medium.webp';
import dnailsDesktopImage1Big from './dnails_desktop_1_big.webp';
import dnailsDesktopImage1 from './dnails_desktop_1.webp';
import dnailsDesktopImage2Small from './dnails_desktop_2_small.webp';
import dnailsDesktopImage2Medium from './dnails_desktop_2_medium.webp';
import dnailsDesktopImage2Big from './dnails_desktop_2_big.webp';
import dnailsDesktopImage2 from './dnails_desktop_2.webp';
import dnailsDesktopImage3Small from './dnails_desktop_3_small.webp';
import dnailsDesktopImage3Medium from './dnails_desktop_3_medium.webp';
import dnailsDesktopImage3Big from './dnails_desktop_3_big.webp';
import dnailsDesktopImage3 from './dnails_desktop_3.webp';
import dnailsDesktopImage4Small from './dnails_desktop_4_small.webp';
import dnailsDesktopImage4Medium from './dnails_desktop_4_medium.webp';
import dnailsDesktopImage4Big from './dnails_desktop_4_big.webp';
import dnailsDesktopImage4 from './dnails_desktop_4.webp';

import atroLogo from './atro_logo.webp';
import atroLogoSmall from './atro_logo_small.webp';
import atroCodeImage1Small from './atro_code_1_small.webp';
import atroCodeImage1Medium from './atro_code_1_medium.webp';
import atroCodeImage1Big from './atro_code_1_big.webp';
import atroCodeImage1 from './atro_code_1.webp';
import atroCodeImage2Small from './atro_code_2_small.webp';
import atroCodeImage2Medium from './atro_code_2_medium.webp';
import atroCodeImage2Big from './atro_code_2_big.webp';
import atroCodeImage2 from './atro_code_2.webp';
import atroCodeImage3Small from './atro_code_3_small.webp';
import atroCodeImage3Medium from './atro_code_3_medium.webp';
import atroCodeImage3Big from './atro_code_3_big.webp';
import atroCodeImage3 from './atro_code_3.webp';

import portfolioV1Logo from './portfolio_v1_logo.webp';
import portfolioV1LogoSmall from './portfolio_v1_logo_small.webp';
import portfolioV1MobileImage1 from './portfolio_v1_mobile_1.webp';
import portfolioV1MobileImage2 from './portfolio_v1_mobile_2.webp';
import portfolioV1MobileImage3 from './portfolio_v1_mobile_3.webp';
import portfolioV1MobileImage4 from './portfolio_v1_mobile_4.webp';
import portfolioV1DesktopImage1Small from './portfolio_v1_desktop_1_small.webp';
import portfolioV1DesktopImage1Medium from './portfolio_v1_desktop_1_medium.webp';
import portfolioV1DesktopImage1Big from './portfolio_v1_desktop_1_big.webp';
import portfolioV1DesktopImage1 from './portfolio_v1_desktop_1.webp';
import portfolioV1DesktopImage2Small from './portfolio_v1_desktop_2_small.webp';
import portfolioV1DesktopImage2Medium from './portfolio_v1_desktop_2_medium.webp';
import portfolioV1DesktopImage2Big from './portfolio_v1_desktop_2_big.webp';
import portfolioV1DesktopImage2 from './portfolio_v1_desktop_2.webp';
import portfolioV1DesktopImage3Small from './portfolio_v1_desktop_3_small.webp';
import portfolioV1DesktopImage3Medium from './portfolio_v1_desktop_3_medium.webp';
import portfolioV1DesktopImage3Big from './portfolio_v1_desktop_3_big.webp';
import portfolioV1DesktopImage3 from './portfolio_v1_desktop_3.webp';
import portfolioV1DesktopImage4Small from './portfolio_v1_desktop_4_small.webp';
import portfolioV1DesktopImage4Medium from './portfolio_v1_desktop_4_medium.webp';
import portfolioV1DesktopImage4Big from './portfolio_v1_desktop_4_big.webp';
import portfolioV1DesktopImage4 from './portfolio_v1_desktop_4.webp';

export const projectImages = {
  pizzaBuilderLogo,
  pizzaBuilderLogoSmall,
  pizzaBuilderMobileImage1,
  pizzaBuilderMobileImage2,
  pizzaBuilderMobileImage3,
  pizzaBuilderDesktopImage1Small,
  pizzaBuilderDesktopImage1Medium,
  pizzaBuilderDesktopImage1Big,
  pizzaBuilderDesktopImage1,
  pizzaBuilderDesktopImage2Small,
  pizzaBuilderDesktopImage2Medium,
  pizzaBuilderDesktopImage2Big,
  pizzaBuilderDesktopImage2,
  pizzaBuilderDesktopImage3Small,
  pizzaBuilderDesktopImage3Medium,
  pizzaBuilderDesktopImage3Big,
  pizzaBuilderDesktopImage3,
  pizzaVSLogo,
  pizzaVSLogoSmall,
  pizzaVSMobileImage1,
  pizzaVSMobileImage2,
  pizzaVSMobileImage3,
  pizzaVSDesktopImage1Small,
  pizzaVSDesktopImage1Medium,
  pizzaVSDesktopImage1Big,
  pizzaVSDesktopImage1,
  pizzaVSDesktopImage2Small,
  pizzaVSDesktopImage2Medium,
  pizzaVSDesktopImage2Big,
  pizzaVSDesktopImage2,
  pizzaVSDesktopImage3Small,
  pizzaVSDesktopImage3Medium,
  pizzaVSDesktopImage3Big,
  pizzaVSDesktopImage3,
  dnailsLogo,
  dnailsLogoSmall,
  dnailsMobileImage1,
  dnailsMobileImage2,
  dnailsMobileImage3,
  dnailsMobileImage4,
  dnailsDesktopImage1Small,
  dnailsDesktopImage1Medium,
  dnailsDesktopImage1Big,
  dnailsDesktopImage1,
  dnailsDesktopImage2Small,
  dnailsDesktopImage2Medium,
  dnailsDesktopImage2Big,
  dnailsDesktopImage2,
  dnailsDesktopImage3Small,
  dnailsDesktopImage3Medium,
  dnailsDesktopImage3Big,
  dnailsDesktopImage3,
  dnailsDesktopImage4Small,
  dnailsDesktopImage4Medium,
  dnailsDesktopImage4Big,
  dnailsDesktopImage4,
  atroLogo,
  atroLogoSmall,
  atroCodeImage1Small,
  atroCodeImage1Medium,
  atroCodeImage1Big,
  atroCodeImage1,
  atroCodeImage2Small,
  atroCodeImage2Medium,
  atroCodeImage2Big,
  atroCodeImage2,
  atroCodeImage3Small,
  atroCodeImage3Medium,
  atroCodeImage3Big,
  atroCodeImage3,
  portfolioV1Logo,
  portfolioV1LogoSmall,
  portfolioV1MobileImage1,
  portfolioV1MobileImage2,
  portfolioV1MobileImage3,
  portfolioV1MobileImage4,
  portfolioV1DesktopImage1Small,
  portfolioV1DesktopImage1Medium,
  portfolioV1DesktopImage1Big,
  portfolioV1DesktopImage1,
  portfolioV1DesktopImage2Small,
  portfolioV1DesktopImage2Medium,
  portfolioV1DesktopImage2Big,
  portfolioV1DesktopImage2,
  portfolioV1DesktopImage3Small,
  portfolioV1DesktopImage3Medium,
  portfolioV1DesktopImage3Big,
  portfolioV1DesktopImage3,
  portfolioV1DesktopImage4Small,
  portfolioV1DesktopImage4Medium,
  portfolioV1DesktopImage4Big,
  portfolioV1DesktopImage4,
};
